<template>
	<VerticalLayout>
		<TroposphereDelaysChart v-if="showTroposphereDelaysChart" />
		<IonosphereResidualsChart v-if="allowPppGp" />
	</VerticalLayout>
</template>

<script>
import { computed } from 'vue';

import { useLicenseStore } from '@/stores/licenseStore';

import VerticalLayout from '@/components/common/VerticalLayout';
import TroposphereDelaysChart from '@/components/stats/TroposphereDelaysChart.vue';
import IonosphereResidualsChart from '@/components/stats/IonosphereResidualsChart.vue';

export default {
	components: {
		VerticalLayout,
		TroposphereDelaysChart,
		IonosphereResidualsChart,
	},
	setup() {
		const licenseStore = useLicenseStore();
		const showTroposphereDelaysChart = computed(() => (
			licenseStore.allowVrs || licenseStore.allowPppRtk
		));
		const allowPppGp = computed(() => licenseStore.allowPppGp);

		return {
			showTroposphereDelaysChart,
			allowPppGp,
		};
	},
}
</script>
